<template>
<div>


<!--   <Section background="white"  class="image-bg"-->
<!--            :style="{'background-image': `url(${require('../../assets/images/content/pexels-pixabay-414781-cropped.jpg')})`}"-->

<!--   >-->

<!--      <nav-bar dark></nav-bar>-->
<!--      &lt;!&ndash;      <div class=" main-heading heading-line pt-1">&ndash;&gt;-->
<!--      &lt;!&ndash;      </div>&ndash;&gt;-->

<!--&lt;!&ndash;      <div class=" main-heading heading-line" style=" width: 100%;" >&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->

<!--      <div class=" main-heading" style=" width: 100%;" >-->
<!--         <v-container fluid class="heading-line">-->
<!--            <div class="center display-2">Videos</div>-->
<!--         </v-container>-->
<!--      </div>-->


<!--   </Section>-->







   <section class="pa-9">
      <article >

         <h1>Recharge Your Batteries</h1>
         <p>
            Sermon by Dr. Namihira at the Vicksburg SDA church.
         </p>

         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/0_59NUilOHo?rel=0" frameborder="0" allowfullscreen></iframe>
         </div>



      </article>

   </section>

   <section class="pa-9">
      <article >

         <h1>The Love of God</h1>
         <p>
            Performance by Yoshinobu and Mieko Namihira
         </p>

         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/rIZWEmvSVIU?rel=0" frameborder="0" allowfullscreen></iframe>
         </div>
         
         

         
         
      </article>

   </section>
   
   
   <section class="pa-9">
      <article >
         <h1>Attitude of Gratitude</h1>
         <p>
            Sermon by Dr. Namihira
         </p>
         <div class="flex-center">
            <iframe width="640" height="480" src="https://www.youtube.com/embed/RFvt-1s9G5U?si=4D_34dQFi0reVDde"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
         </div>
         
      </article>
   
   </section>
   
   <section class="pa-9">
      <article >
         <h1>Diet and Cancer</h1>
         <p>
            Sermon by Dr. Namihira 4/1/2023
         </p>
         <div class="flex-center">
            <iframe width="640" height="480" src="https://www.youtube.com/embed/pmzT8AFSFX4?si=cLNRDE0I-EwT_gCg"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
         </div>
      
      </article>
   
   </section>
   
   
   <section class="pa-9">
      <article >
         <h1>It Is Well With My Soul</h1>
         <p>
            Special Music by Dr and Mrs Namihira
         </p>
         <div class="flex-center">
            <iframe width="640" height="480" src="https://www.youtube.com/embed/DsjXv53ghGY?si=8Qtrxlkl0RYOtvtk"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
         </div>
      </article>
   </section>
   
   
   <section class="pa-9">
      <article >
         <h1>Rejoice Always in The Lord</h1>
         <p>
            Sermon by Dr. Namihira
         </p>
         <div class="flex-center">
            <iframe width="640" height="480" src="https://www.youtube.com/embed/7f4MVXsWrIE?si=lB8AaH24faSdP4q6"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
         </div>
      </article>
   </section>
   
   
   <section class="pa-9">
      <article >
         <h1>The Haven of Rest</h1>
         <p>
            Special Music by Dr and Mrs Namihira
         </p>
         <div class="flex-center">
            <iframe width="640" height="480" src="https://www.youtube.com/embed/Cs4FJnk4d-A?si=DcjmK82L4hBq192W"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
         </div>
      </article>
   </section>
   

</div>
</template>

<script>

import navBar from '@/components/navBar.vue'
import Section from "@/components/Section";
import AudioPlayer from "@/components/AudioPlayer";

export default {
name: "Radio",
   components: {navBar, Section, AudioPlayer},
}
</script>

<style scoped>
.image-bg{
   background-size: cover;
   background-position: center;
   height: 300px;
}

   td{
      padding-left: 10px;
      padding-right: 10px;
   }


.main-heading{
   height: 200px;
   display: flex;
   align-items: center;
   justify-content: center;

}


.heading-line{
   text-align: center;
   color:#ffffff;
   /*background-color:rgba(43,43,43,0.4);*/
   width: 100%;

}

</style>
